export enum OrderStatuses {
  CANCELLED,
  AWAITING_PAYMENT,
  PROCESSING,
  PACKING,
  SHIPPING,
  DELIVERED,
}
export enum ParcelStatuses {
  DELIVERED,
  AT_DELIVERY_PROVIDER,
  TRANSFERRING_TO_DELIVERY_PROVIDER,
  PACKED_IN_WAREHOUSE,
  IN_PREPARATION,
}

export class ParcelStatus {
  status: ParcelStatuses;
  trackingLink?: string;

  constructor(status: ParcelStatuses, trackingLink?: string) {
    this.status = status;
    this.trackingLink = trackingLink;
  }
}

export class OrderStatus {
  status: OrderStatuses;
  parcels?: ParcelStatus[];

  constructor(data: { status: OrderStatuses; parcels?: ParcelStatus[] }) {
    this.status = data.status;
    this.parcels = data.parcels;
  }
}

export const OrderStatusesMapping = {
  CANCELLED: 'order_cancelled',
  AWAITING_PAYMENT: 'order_awaiting',
  PROCESSING: 'order_processing',
  PACKING: 'order_packing',
  SHIPPING: 'order_shipping',
  DELIVERED: 'order_delivered',
};
export const ParcelStatusesMapping = {
  DELIVERED: 'parcel_delivered',
  AT_DELIVERY_PROVIDER: 'parcel_handed',
  TRANSFERRING_TO_DELIVERY_PROVIDER: 'parcel_transferred',
  PACKED_IN_WAREHOUSE: 'parcel_packed',
  IN_PREPARATION: 'parcel_packing',
};
